<div
  *transloco="let t"
  class="w-full bg-white h-[80px] lg:h-[98px] flex items-center"
>
  <app-mb-content-container class="flex w-full items-center justify-between">
    <div class="flex items-center gap-16">
      <app-mb-logo  class="hidden lg:block" />
      <app-mb-logo class="lg:hidden" size="small" />
      <div class="hidden lg:block">
        <app-mb-menu-links />
      </div>
    </div>

    <div class="flex items-center gap-4">
      <div class="hidden lg:block">
        <app-user-profile *ngIf="isAuthenticated$ | async; else loginButton" />
        <ng-template #loginButton>
          <app-user-profile />
        </ng-template>
      </div>

      <div class="flex items-center">
        <app-mb-language-selector />
          <button
            class="flex items-center justify-center rounded-md p-2 transition-colors hover:bg-gray-100 active:bg-gray-200 lg:hidden"
            (click)="toggleMobileMenu()"
            [attr.aria-label]="isMobileMenuOpen ? 'Close menu' : 'Open menu'"
            [attr.aria-expanded]="isMobileMenuOpen"
            >
            <svg
            class="h-5 w-5 sm:h-6 sm:w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            >
            <path
            *ngIf="!isMobileMenuOpen"
            d="M4 6h16M4 12h16M4 18h16"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            />
            <path
            *ngIf="isMobileMenuOpen"
            d="M6 18L18 6M6 6l12 12"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            />
          </svg>
          </button>
    </div>
    </div>
  </app-mb-content-container>

  <app-mb-drawer
    title="{{ t('menu') }}"
    [isVisible]="isMobileMenuOpen"
    (isVisibleChange)="isMobileMenuOpen = $event"
    (OkActionHandler)="closeMobileMenu()"
    placement="right"
  >
  <div class="h-full flex flex-col justify-between">
    <div>
      <div class="w-full flex items-center justify-between p-[18px]">
        <span class="text-mbaza-gray uppercase">{{t('menu')}}</span>
        <button
          class="flex items-center justify-center rounded-md p-2 transition-colors hover:bg-gray-100 active:bg-gray-200 lg:hidden"
          (click)="closeMobileMenu()"
          [attr.aria-label]="'Close menu'"
          >
          <svg
            class="h-5 w-5 sm:h-6 sm:w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
            d="M6 18L18 6M6 6l12 12"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            />
          </svg>
        </button>
      </div>
      <app-mb-menu-links />

      <div class="px-[16px] mt-8">
        <app-user-profile *ngIf="isAuthenticated$ | async; else loginButton" />
        <ng-template #loginButton>
          <app-user-profile />
        </ng-template>
      </div>
    </div>

    <div class="w-full grid place-items-center p-4">
      <app-mb-language-selector />
    </div>
  </div>
  </app-mb-drawer>
</div>